const STORAGE_KEY_SNOOZE = 'fipContactBannerSnoozeUntil';
const SESSION_KEY_DISMISSED = 'fipContactBannerDismissed';
const SESSION_KEY_SHOWN = 'fipContactBannerShown';
const SNOOZE_DAYS = 30;
export class FipContactBanner {
    constructor() {
        this.id = 'fip-contact-banner-modal';
    }
    static resetForNewLogin() {
        sessionStorage.removeItem(SESSION_KEY_DISMISSED);
        sessionStorage.removeItem(SESSION_KEY_SHOWN);
    }
    init() {
        if (sessionStorage.getItem(SESSION_KEY_DISMISSED) || sessionStorage.getItem(SESSION_KEY_SHOWN)) {
            return;
        }
        const snoozeUntil = Number(localStorage.getItem(STORAGE_KEY_SNOOZE));
        if (snoozeUntil && Date.now() < snoozeUntil) {
            return;
        }
        sessionStorage.setItem(SESSION_KEY_SHOWN, '1');
        this.show();
    }
    show() {
        const newDiv = document.createElement('div');
        newDiv.innerHTML = `
        <div class="modal fade" id="${this.id}" tabindex="-1" aria-labelledby="${this.id}Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header alert-warning">
                <h5 class="modal-title" id="${this.id}Label">Insurance Data Quality Center Portal Users</h5>
                <button type="button" class="btn-close" id="${this.id}-x" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Please ensure that your primary and secondary Fair Information Practices (FIP) Contacts'
                information is current and accurate in our systems. To update a FIP Contact, please complete the
                "Request New User" form linked at the top of the portal page. Maintaining current FIP contact
                information within our systems is important to the timely processing and resolution of consumer
                disputes. Thank you for your assistance in helping uphold our organizations' commitments to protect
                consumer rights and maintain data accuracy.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" id="${this.id}-snooze">
                    Do not show this for ${SNOOZE_DAYS} days
                </button>
              </div>
            </div>
          </div>
        </div>`;
        document.body.appendChild(newDiv);
        const modalEl = document.getElementById(this.id);
        const modal = new window.bootstrap.Modal(modalEl);
        const dismissForSession = () => {
            sessionStorage.setItem(SESSION_KEY_DISMISSED, '1');
            modal.hide();
        };
        const snoozeFor30Days = () => {
            localStorage.setItem(STORAGE_KEY_SNOOZE, String(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
            modal.hide();
        };
        document.getElementById(`${this.id}-x`).addEventListener('click', dismissForSession);
        document.getElementById(`${this.id}-snooze`).addEventListener('click', snoozeFor30Days);
        modalEl.addEventListener('hidden.bs.modal', () => {
            modalEl.parentElement.remove();
        });
        modal.show();
    }
}
